import React from "react";

// Kit badge: a static info box, not clickable (anything you tap is a Chip or a Button).
// category, hashtags, date / time, venue type, amenities, account type.
//   size    sm (text-2xs, inside cards) | md (default, text-xs) | lg (text-md, category on cards)
//           | xl (text-lg, category on the details page)
//   strong  stronger fill for the key facts (date, time)
// Styles: .inyc-badge in src/styles/ui-kit.css.
const Badge = ({ size = "md", strong = false, icon = null, className = "", children, ...rest }) => (
  <span
    className={["inyc-badge", size === "sm" && "is-sm", size === "lg" && "is-lg", size === "xl" && "is-xl", strong && "is-strong", className].filter(Boolean).join(" ")}
    {...rest}
  >
    {icon}
    {children}
  </span>
);

export default Badge;
